import { ArrowRight } from "lucide-react";

const QuickActionButton = ({ onClick, icon: Icon, label, description, color }) => {
    const colorClasses = {
        blue: 'group-hover:bg-blue-50 group-hover:text-blue-700',
        green: 'group-hover:bg-green-50 group-hover:text-green-700',
        purple: 'group-hover:bg-purple-50 group-hover:text-purple-700'
    };

    return (
        <button 
            onClick={onClick} 
            className={`group w-full flex justify-between items-center p-4 rounded-xl text-left transition-all duration-300 hover:shadow-md ${colorClasses[color]}`}
        >
            <div className="flex items-center flex-1">
                <div className="p-2 bg-secondary-100 rounded-lg mr-4 group-hover:scale-110 transition-transform duration-300">
                    <Icon className="w-5 h-5 text-secondary-600 group-hover:text-primary-600 transition-colors duration-300" />
                </div>
                <div>
                    <div className="font-semibold text-secondary-800 group-hover:text-primary-700 transition-colors duration-300">
                        {label}
                    </div>
                    <div className="text-xs text-secondary-500 mt-1">
                        {description}
                    </div>
                </div>
            </div>
            <ArrowRight className="w-5 h-5 text-secondary-400 group-hover:text-secondary-600 transition-all duration-300 group-hover:translate-x-1" />
        </button>
    );
};

export default QuickActionButton;